import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_CATEGORY } from "../apiRoutes";

const mutateAddTaskCategory = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(TASK_CATEGORY, data);
};

const useAddTaskCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddTaskCategory,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch task category queries
      queryClient.invalidateQueries({
        queryKey: ["taskCategory"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddTaskCategoryMutation;
